import React from 'react';
import { Link } from 'react-router-dom';
import { Button, FieldGroup } from '@ver-uds/react';
import classNames from 'classnames';
import { Account, AccountType } from 'eve-account-client';
import Section from './Section';

type OnButtonClick = { onEditButtonClick: () => void; editUrl?: never };
type EditUrl = { editUrl: string; onEditButtonClick?: never };

export type CompanyLocationsProps = {
  accountData?: Pick<Account, 'companyInfo' | 'type'>;
} & (OnButtonClick | EditUrl);

const CompanyLocations = ({ accountData, editUrl, onEditButtonClick }: CompanyLocationsProps): JSX.Element => {
  const companyInfoData = accountData?.companyInfo;

  const physicalAddress = companyInfoData?.physicalLocation;
  const mailingAddress = companyInfoData?.mailingAddress;

  const isCorporateAccount = accountData?.type === AccountType.CORPORATE;

  const pageTitle = 'Company Addresses';

  return (
    <Section
      title="Company Addresses"
      className={classNames({
        'grid-col-12 tablet:grid-col-6': !isCorporateAccount,
      })}
      data-testid="company-addresses"
    >
      <FieldGroup className="grid-row grid-gap">
        <FieldGroup.Field className="grid-col-12" name="Physical Address">
          {physicalAddress ? (
            <>
              <address>
                {physicalAddress?.line1}
                <br />
                {physicalAddress?.line2 ? (
                  <>
                    {physicalAddress?.line2}
                    <br />
                  </>
                ) : null}
                {physicalAddress?.city}, {physicalAddress?.stateCode} {physicalAddress?.zipCode}
              </address>
            </>
          ) : (
            '---'
          )}
        </FieldGroup.Field>
        <FieldGroup.Field
          className={classNames({
            'grid-col-6': isCorporateAccount,
            'grid-col-12': !isCorporateAccount,
          })}
          name="Mailing Address"
        >
          {mailingAddress ? (
            <>
              <address>
                {mailingAddress?.line1}
                <br />
                {mailingAddress?.line2 ? (
                  <>
                    {mailingAddress?.line2}
                    <br />
                  </>
                ) : null}
                {mailingAddress?.city}, {mailingAddress?.stateCode} {mailingAddress?.zipCode}
              </address>
            </>
          ) : (
            'Same as Physical Address'
          )}
        </FieldGroup.Field>
      </FieldGroup>

      {onEditButtonClick ? (
        <Button onClick={onEditButtonClick} className="usa-button usa-button--outline">
          Edit Company Addresses
        </Button>
      ) : (
        <Link to={editUrl || ''} className="usa-button usa-button--outline">
          Edit {pageTitle}
        </Link>
      )}
    </Section>
  );
};

export default CompanyLocations;
